module.exports = __webpack_public_path__ + "img/al.7e21b496.svg";